import BasicPopup from './BasicPopup'
import BooleanDialog from './BooleanDialog'
import CopyToClipboard from './CopyToClipboard'
import GeoportalMap from './GeoportalMap'
import ImageDialog from './ImageDialog'
import LoadingMapState from './LoadingMapState'
import PopupData from './PopupData'
import PrintDate from './PrintDate'
import QueryOnClick from './QueryOnClick'
import ResultPanelMixin from './ResultPanelMixin'
import SearchBar from './SearchBar'
import SearchResult from './SearchResult'
import SearchResultPopupDialog from './SearchResultPopupDialog'
import Sidebar from './Sidebar'
import ValidatedInput from './ValidatedInput'
import dataLayer from './data-layer'

export default {
  BasicPopup,
  BooleanDialog,
  CopyToClipboard,
  GeoportalMap,
  ImageDialog,
  LoadingMapState,
  PopupData,
  PrintDate,
  QueryOnClick,
  ResultPanelMixin,
  SearchBar,
  SearchResult,
  SearchResultPopupDialog,
  Sidebar,
  ValidatedInput,
  dataLayer
}
